import { Slide01Title } from './Slide01Title'
import { Slide02Challenge } from './Slide02Challenge'
import { Slide03Funnel } from './Slide03Funnel'
import { Slide04Example } from './Slide04Example'
import { Slide05Hollywood } from './Slide05Hollywood'
import { Slide05Different } from './Slide05Different'
import { Slide06Impact } from './Slide06Impact'

export const slides = [
  Slide01Title,
  Slide02Challenge,
  Slide03Funnel,
  Slide04Example,
  Slide05Hollywood,
  Slide05Different,
  Slide06Impact,
]
